import React, { useState, useEffect } from 'react';
import { supabase } from '../../lib/supabase'; // <-- Vérifiez que ce chemin pointe bien vers votre fichier supabase.js
import Icon from '../AppIcon'; // <-- Vérifiez que ce chemin pointe bien vers votre composant Icon

const DownloadKpsCreator = () => {
  const [releaseInfo, setReleaseInfo] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchRelease = async () => {
      try {
        const { data, error } = await supabase
          .from('kps_creator_releases')
          .select('*')
          .eq('is_active', true)
          .single();
        
        if (!error && data) {
          setReleaseInfo(data);
        }
      } catch (err) {
        console.error("Erreur de chargement du lien KPS Creator", err);
      } finally {
        setLoading(false);
      }
    };
    fetchRelease();
  }, []);

  const handleDownload = async () => {
    if (!releaseInfo) return;
    
    // 1. Ouvre le lien de téléchargement (dans un nouvel onglet pour ne pas bloquer l'utilisateur)
    window.open(releaseInfo.download_url, '_blank');
    
    // 2. Incrémente le compteur en arrière-plan via Supabase RPC
    try {
      await supabase.rpc('increment_kps_download', {
        release_id: releaseInfo.id
      });
    } catch (e) {
      console.error("Erreur d'incrémentation", e);
    }
  };

  // État de chargement élégant (Skeleton) avant que Supabase ne réponde
  if (loading) {
    return (
      <div className="py-3.5 px-8 rounded-2xl border border-white/5 bg-white/5 animate-pulse w-64 h-[52px]" />
    );
  }

  return (
    <button 
      onClick={handleDownload}
      disabled={!releaseInfo}
      className={`
        group relative flex items-center justify-center gap-3 py-3.5 px-8 rounded-2xl font-bold text-sm tracking-wide transition-all duration-300 border-none outline-none overflow-hidden
        ${!releaseInfo 
          ? 'bg-white/5 text-white/30 cursor-not-allowed' 
          : 'bg-brand-gold text-black hover:bg-yellow-400 hover:-translate-y-0.5 shadow-[0_0_20px_rgba(212,175,55,0.2)] hover:shadow-[0_0_30px_rgba(212,175,55,0.4)] cursor-pointer'
        }
      `}
    >
      {/* Effet de brillance (shimmer) au survol pour le côté premium */}
      {releaseInfo && (
        <div className="absolute inset-0 bg-white/30 -skew-x-12 -translate-x-full group-hover:animate-[shimmer_1.5s_infinite]" />
      )}
      
      <Icon name="Download" size={18} className={!releaseInfo ? 'text-white/30' : 'text-black'} />
      <span className="relative z-10 uppercase tracking-widest font-heading">
        Télécharger {releaseInfo ? `(v${releaseInfo.version})` : 'Indisponible'}
      </span>
      
      {/* Balise style pour l'animation locale */}
      <style>{`
        @keyframes shimmer {
          100% { transform: translateX(200%); }
        }
      `}</style>
    </button>
  );
};

export default DownloadKpsCreator;